document.addEventListener("DOMContentLoaded", function() {
  // Function to handle scroll events
  function handleScroll() {
    const windowWidth = window.innerWidth; // Get the current window width

    // Get the elements by their class names
    const headerNav = document.querySelector('.header__nav');
    const menuMain = document.querySelector('.menu--main');
    const mainSearch = document.querySelector('.main-search');
    const searchTextElements = document.querySelectorAll('.search-text');

    // Check the scroll position and update classes accordingly
    const scrollPosition = window.scrollY;

    if (windowWidth >= 1025) {
      if (scrollPosition >= 0 && scrollPosition <= 140) {
        // Remove classes if scroll is between 0 and 140px
        headerNav.classList.remove('ml-100');
        menuMain.classList.remove('ml-45');
        mainSearch.classList.remove('mr-100');
        mainSearch.classList.remove('pr-15');

        // Reset color for search-text elements
        searchTextElements.forEach((element) => {
          element.style.color = ''; // Reset to default color
        });

      } else {
        // Add classes back if scroll is not between 0 and 140px
        headerNav.classList.add('ml-100');
        menuMain.classList.add('ml-45');
        mainSearch.classList.add('mr-100');
        mainSearch.classList.add('pr-15');

        // Change color for search-text elements
        searchTextElements.forEach((element) => {
          element.style.color = '#39667b'; // Set color to #39667b
        });
      }
    }

    // Additional condition to remove classes when window width is from 1279px
    if (windowWidth <= 1279) {
      headerNav.classList.remove('ml-100');
      menuMain.classList.remove('ml-45');
      mainSearch.classList.remove('mr-100');
    }
  }

  // Call handleScroll once to set the initial state
  handleScroll();

  // Attach the handleScroll function to the scroll event
  window.addEventListener('scroll', handleScroll);
});



// on scroll header width, visibility, and alignment
// document.addEventListener("DOMContentLoaded", function() {
//   // Function to handle scroll events
//   function handleScroll() {
//     // Get the current scroll position
//     const scrollPosition = window.scrollY;

//     // Get the elements by their class names
//     const headerNav = document.querySelector('.header__nav');
//     const menuMain = document.querySelector('.menu--main');
//     const mainSearch = document.querySelector('.main-search');
//     const searchTextElements = document.querySelectorAll('.search-text'); // Added this line

//     // Check the scroll position and update classes accordingly
//     if (scrollPosition >= 0 && scrollPosition <= 140) {
//       // Remove classes if scroll is between 0 and 140px
//       headerNav.classList.remove('ml-100');
//       menuMain.classList.remove('ml-45');
//       mainSearch.classList.remove('mr-100');
//       mainSearch.classList.remove('pr-15');

//       // Reset color for search-text elements
//       searchTextElements.forEach((element) => {
//         element.style.color = ''; // Reset to default color
//       });

//     } else {
//       // Add classes back if scroll is not between 0 and 140px
//       headerNav.classList.add('ml-100');
//       menuMain.classList.add('ml-45');
//       mainSearch.classList.add('mr-100');
//       mainSearch.classList.add('pr-15');

//       // Change color for search-text elements
//       searchTextElements.forEach((element) => {
//         element.style.color = '#39667b'; // Set color to #39667b
//       });
//     }
//   }

//   // Call handleScroll once to set the initial state
//   handleScroll();

//   // Attach the handleScroll function to the scroll event
//   window.addEventListener('scroll', handleScroll);
// });




// // header search icon cursor and route fix 
// document.addEventListener("DOMContentLoaded", function() {
//   const searchUrl = "{{ routes.search_url }}"; // Set the URL here

//   const iconSelector = document.querySelector('.icon-selector');
//   iconSelector.style.cursor = "pointer";

//   iconSelector.addEventListener('click', function() {
//     window.location.href = searchUrl; // Use the variable here
//   });
// });



